export const visit = (vm, at) => {
at({ "en": { "calling-orchestration-shared-library": { "save-bar": { "save": "Save", "cancel": "Cancel", "changedSettingsCount": { "one": "You've changed {{ count }} setting.", "other": "You've changed {{ count }} settings." } } } } });
};